import { GameRunnerProps } from './types';
import { GameRunnerList, GameRunnerMap } from './GameRunnerList';

export function GameRunner({ title, src, version = '0.7.1', clientID, onReady }: GameRunnerProps) {
    const Runner = GameRunnerMap.get(GameRunnerList.indexOf(version) >= 0 ? version : '0.7.1');

    if (!Runner) {
        throw new Error(`GameRunner version ${version} is not supported`);
    }
    return <Runner title={title} src={src} clientID={clientID} onReady={onReady} />;
}
